import React from 'react';

const CIStats = ({ counts }) => {
  return (
    <div className="contribution-stats">
      <div className="contribution-stats-item">
        <span>Documents:</span>
        <span>{counts.documents.toLocaleString()}</span>
      </div>
      <div className="contribution-stats-item">
        <span>Focuses:</span>
        <span>{counts.focuses.toLocaleString()}</span>
      </div>
    </div>
  );
};

export default CIStats;
